import React from 'react';
import styles from './FilterTag.module.scss';
import { useFilter } from '@srcDS/tastic/pages/category/hooks/useFilter';
import clsx from 'clsx';
import FilterTagCloseCross from '../../atoms/icons/FilterTagClose';
import { FilterTagItem, UseFilterReturn, FilterTagProps } from './types';

export const FilterTag: React.FC<FilterTagProps> = ({ filters = [], showClearAll = true, onClick = () => {} }) => {
  const { handleTagRemoval, handleClearAllFacets }: UseFilterReturn = useFilter();

  return (
    <div className={styles.container}>
      {filters.map((filter: FilterTagItem, index: number) => {
        return (
          <div key={`${filter.attrId}_${index}`} className={styles.filter}>
            <p>{filter.name}</p>
            <div
              className={styles.closeIcon}
              onClick={() => {
                handleTagRemoval(filter.attrId, filter.name);
                onClick();
              }}
            >
              <FilterTagCloseCross />
            </div>
          </div>
        );
      })}
      {showClearAll && filters.length > 0 && (
        <div className={clsx(styles.filter, styles.filterClearAll)} onClick={handleClearAllFacets}>
          <p>Clear all</p>
        </div>
      )}
    </div>
  );
};
